// Import Core
import React from 'react';
import styled from 'styled-components';
// Import Libraries
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
// Import Components
import Button from '../ui/buttons/Button';
import { toSlug } from '../../utils/search/toSlug';

/* Styled Components */
const ThreeCardGridStyles = styled.section`
	background: var(--white);
  padding: var(--global-padding);
  @media(max-width: 768px) {
		padding: var(--global-padding-mobile);
  }
	> div {
    .gatsby-image-wrapper {
      width: 100%;
      img {
        height: auto;
      }
    }
    .top-cards, .bottom-cards, .end-card, .content {
      display: flex;
      @media(max-width: 768px) {
        flex-direction: column;
      }
    }
    .top-cards {
      padding: 36px 0;
      border-bottom: 1px solid var(--neutral-10);
      @media(max-width: 768px) {
        padding: 0 0 32px;
      }
      .section-title {
        padding-right: 36px;
        border-right: 1px solid var(--neutral-10);
        flex: 1;
        @media(max-width: 768px) {
          padding: 0 0 40px;
          border-bottom: 1px solid var(--neutral-10);
          border-right: none;
        }
        h2 {
          padding: 16px 0 24px;
          @media(max-width: 768px) {
            padding: 12px 0 20px;
          }
        }
      }
      .intro-card {
        padding-left: 36px;
        flex: 2;
        @media(max-width: 768px) {
          padding: 40px 0 0 0;
        }
        h3 { 
          padding-bottom: 24px;
          @media(max-width: 768px) {
            padding-bottom: 20px;
          } 
        }
        .first-card {
          padding-top: 32px;
          /* p {
            padding: 8px 0 24px;
          } */
          .gatsby-image-wrapper, img {
            max-height: 365px;
          }
        }
      }
    }
    .bottom-cards {
      padding: 36px 0;
      border-bottom: 1px solid var(--neutral-10);
      @media(max-width: 768px) {
        padding: 32px 0;
      }
      .card {
        &:first-child {
          padding-right: 36px;
          border-right: 1px solid var(--neutral-10);
          @media(max-width: 768px) {
            padding: 0 0 32px;
            border-bottom: 1px solid var(--neutral-10);
            border-right: none;
          }
        }
        &:last-child {
          padding-left: 36px;
          @media(max-width: 768px) {
            padding-left: 0;
            padding: 32px 0 0;
          }
        }
      }
    }
    .first-card p, .card p {
      padding: 8px 0 24px;
      @media(max-width: 768px) {
        padding-bottom: 20px;
      }
    }
    .end-card {
      flex-direction: column;
      padding: 36px 0;
      @media(max-width: 768px) {
        padding: 32px 0 0;
      }
      h3 {
        padding-bottom: 36px;
        @media(max-width: 768px) {
          padding-bottom: 32px;
        }
      }
      .content {
        gap: 36px;
        @media(max-width: 768px) {
          gap: 20px;
        }
        p, div {
          flex: 50%;
        }
      }
    } 
	}
`;

/* Render Component */
const ThreeCardGrid = ({ addToAnchor, sectionTitle, subtitle, description, cards, title, content, image }) => {
  const firstCard = cards[0];
  const lastCards = cards.slice(1, 3);
  
  return (
    <ThreeCardGridStyles id={addToAnchor ? `anchor_${toSlug(sectionTitle.title)}` : ''} className={`${addToAnchor && 'anchor-link'}`}>
      <div>
        <div className='top-cards'>
          <div className='section-title'>
            {sectionTitle.subheading &&
              <p className='tagline italic'>{sectionTitle.subheading} </p>
            }
            <h2>{sectionTitle.title}</h2>
            <p>{sectionTitle.caption}</p>
          </div>
          <div className='intro-card'>
            <div className='intro-content'>
              <h3>{subtitle}</h3>
              <p>{description}</p>
            </div>
            <div className='first-card'>
              <h4 className='alt red'>{firstCard.title}</h4>
              <p>{firstCard.content}</p>
              <GatsbyImage
                image={getImage(firstCard.image.asset)}
                alt='Kirker Holidays'
              />
            </div>
          </div>
        </div>
        <div className='bottom-cards'>
          {lastCards.map((card, index) => (
            <div key={index} className='card'>
              <h4 className='alt red'>{card.title}</h4>
              <p>{card.content}</p>
              <GatsbyImage
                image={getImage(card.image.asset)}
                alt='Kirker Holidays'
              />
            </div>
          ))}
        </div>
        <div className='end-card'>
          <h3 className=''>{title}</h3>
          <div className='content'>
            <p>{content}</p>
            { image ? 
              <GatsbyImage
                image={getImage(image.asset)}
                alt='Kirker Holidays'
              /> : ''
            }
          </div>
        </div>
      </div>
    </ThreeCardGridStyles>
  );
};

export default ThreeCardGrid;
